import type { IconData } from '@stacksjs/iconify-core'

export const moreVerticalF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 6a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0 14a3 3 0 1 1 0-6a3 3 0 0 1 0 6m0-7a3 3 0 1 1 0-6a3 3 0 0 1 0 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default moreVerticalF
